<template>
  <div>
    <!-- <b-button @click="showModal = !showModal">
      Toggle Sidebar
    </b-button> -->

    <b-sidebar
      id="sidebar-backdrop"
      v-model="showModal"
      title="document_number"
      backdrop-variant="white"
      backdrop
      shadow
    >
      <b-row>
        <b-col lg="2">
          <dx-form-group :label="$t('document type')">
            <dx-select-box />
          </dx-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <dx-form-group :label="$t('Contract')">
            <dx-text-box
              value-change-event="input"
              styling-mode="outlined"
              :max-length="45"
            />
          </dx-form-group>
        </b-col>
      </b-row>
    </b-sidebar>
  </div>
</template>

<script>
import {
  DxSelectBox,
  DxTextBox,
  // DxNumberBox,
  // DxCheckBox,
  // DxDateBox,
  // DxTextArea,
  // DxFileUploader,
  // DxButton,
} from 'devextreme-vue';

// import { DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
// import { DxAutocomplete } from 'devextreme-vue/autocomplete';
// import { DxPopup } from 'devextreme-vue/popup';
// import { DxScrollView } from 'devextreme-vue/scroll-view';
// import { DxRadioGroup } from 'devextreme-vue/radio-group';


// import {
//   DxDataGrid,
//   DxExport,
//   DxColumn,
//   DxEditing,
//   DxHeaderFilter,
//   DxGroupPanel,
//   DxSearchPanel,
//   DxSelection,
//   DxStateStoring,
//   DxPaging,
//   DxPager,
//   DxLookup,
// } from 'devextreme-vue/data-grid';

import DxFormGroup from '@/components/common/DxFormGroup';
// import DxFieldsetHeader from '@/components/common/DxFieldsetHeader';

export default {
  name: 'DescribeDocumentModal',

  components: {
    // DxAutocomplete,
    DxSelectBox,
    DxTextBox,
    // DxNumberBox,
    // DxDateBox,
    // DxTextArea,
    // DxCheckBox,
    DxFormGroup,
    // DxFieldsetHeader,
    // DxDataGrid,
    // DxExport,
    // DxColumn,
    // DxLookup,
    // DxEditing,
    // DxHeaderFilter,
    // DxGroupPanel,
    // DxSearchPanel,
    // DxSelection,
    // DxStateStoring,
    // DxFileUploader,
    // DxPaging,
    // DxPager,
    // DxButton,
    // DxPopup,
    // DxScrollView,
    // DxRadioGroup,
    // ConsigmentInfoModal,
    // AutocompleteModal,
    // DxTextBoxButton,
  },

  data() {
    return {
      showModal: false,
    };
  },
};
</script>
